import React from "react";
import { Panel } from "../components/Panel";
import { Button } from "../components/Button";
import { Card } from "./Card";
import { MutedText } from "./MutedText";
import { Stack } from "../../../components/UI";
import { FileInput } from "./FileInput";
import ServiceWorkerButton from "./ServiceWorkerButton";

interface DataSettingsSectionProps {
  onExportData: () => void;
  onImportData: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onResetData: () => void;
}

export const DataSettingsSection: React.FC<DataSettingsSectionProps> = ({
  onExportData,
  onImportData,
  onResetData,
}) => {
  return (
    <Stack gap={20}>
      <Card title="Backups">
        <Stack gap={10}>
          <MutedText>Your data is not stored on a remote server to ensure your privacy. Regular backups are recommended.</MutedText>
          <Button onClick={onExportData} fullWidth>
            Export all data
          </Button>
        </Stack>
      </Card>
      <Card danger title="Danger Zone">
        <Stack gap={20} alignItems="flex-start" data-name="HELLO">
          <Stack gap={10} alignItems="flex-start">
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>Import data</div>
            <MutedText>
              This will replace all the data you currently have with data from selected file. There is no confirmation. This action cannot be undone.
            </MutedText>
            <FileInput onChange={onImportData}></FileInput>
          </Stack>
          <Stack gap={10} alignItems="flex-start">
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>Full Reset</div>
            <MutedText>
              This will delete all your current habits, contexts, and progress data. This action cannot be undone.
            </MutedText>
            <Button
              variant="destructive"
              fullWidth
              onClick={onResetData}
            >
              Full Reset
            </Button>
          </Stack>
        </Stack>
      </Card>
      <Card title="Offline">
        <ServiceWorkerButton />
      </Card>
    </Stack>
  );
};